import React from 'react';
import { Users, Building2, Download, Clock, ShieldCheck, Layers, Smartphone } from 'lucide-react';
const stats = [{
  icon: Users,
  num: '+15K',
  label: 'Professeurs actifs'
}, {
  icon: Building2,
  num: '1.200+',
  label: "Studios l', utilisent,"
}, {
  icon: Download,
  num: '380K+',
  label: 'Routines téléchargées'
}, {
  icon: Clock,
  num: '5h+',
  label: 'Économisées / semaine'
}];
const standards = [{
  icon: ShieldCheck,
  title: 'Base Pédagogique',
  desc: 'Conçu selon des critères anatomiques et de séquençage logique.'
}, {
  icon: Layers,
  title: 'Tous Niveaux',
  desc: 'Adapté pour Débutant, Intermédiaire et Avancé avec progressions claires.'
}, {
  icon: Smartphone,
  title: 'Multi-support',
  desc: 'Tablette, mobile, PC ou à imprimer — utilisez-le où vous voulez.'
}];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-10 sm:py-16 border-y border-border-light px-4 relative overflow-hidden" data-id="element-322">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/[0.04] to-transparent pointer-events-none" data-id="element-323"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-324">
        {/* Rating banner — first trust anchor */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-8 sm:mb-12 text-center" data-id="element-325">
          <span className="text-[#E0A52E] text-base sm:text-lg" aria-hidden="true" data-id="element-326">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-text-main font-bold text-sm sm:text-base" data-id="element-327">
            4.9/5
          </span>
          <span className="text-text-sec text-sm sm:text-base" data-id="element-328">
            · +800 avis vérifiés de professeurs
          </span>
        </div>

        {/* Stats grid with icons */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-10 sm:mb-14" data-id="element-329">
          {stats.map((stat, i) => {
          const Icon = stat.icon;
          return <div key={i} className="text-center sm:text-left flex sm:flex-row flex-col items-center sm:items-start gap-2 sm:gap-3" data-id="element-330">
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0" data-id="element-331">
                  <Icon className="w-5 h-5 text-primary" data-id="element-332" />
                </div>
                <div className="min-w-0" data-id="element-333">
                  <div className="text-text-main font-black text-2xl sm:text-3xl leading-none mb-1" data-id="element-334">
                    {stat.num}
                  </div>
                  <p className="text-text-sec text-xs sm:text-sm font-medium leading-snug" data-id="element-335">
                    {stat.label}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Professional standard */}
        <div className="border-t border-border-light pt-8 sm:pt-10" data-id="element-336">
          <p className="text-center text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs mb-5 sm:mb-6" data-id="element-337">
            ✓ Standard Professionnel
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4" data-id="element-338">
            {standards.map((s, i) => {
            const Icon = s.icon;
            return <div key={i} className="flex items-start gap-3 bg-bg-main/60 border border-border-light rounded-xl px-4 py-3.5 sm:py-4" data-id="element-339">
                  <div className="w-9 h-9 rounded-lg bg-cta-green/10 border border-cta-green/20 flex items-center justify-center flex-shrink-0" data-id="element-340">
                    <Icon className="w-4 h-4 text-cta-green" data-id="element-341" />
                  </div>
                  <div className="min-w-0" data-id="element-342">
                    <p className="text-text-main font-bold text-sm leading-tight mb-0.5" data-id="element-343">
                      {s.title}
                    </p>
                    <p className="text-text-sec text-xs sm:text-[13px] leading-snug" data-id="element-344">
                      {s.desc}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}